import { useEffect, useState } from "react";
// react-router-dom components

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import colors from "../assets/theme/base/colors";
// Image
import PageLayout from "../layouts/dashboards";
import DashboardApplicationContainer from "../pageSections/ApplicationsContainer/DashboardApplicationContainer";
import StatisticsCard from "../components/IRAGeneralComponents/StatisticsCard";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import api from "../api/api.js";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  prepareTicketRows,
  ammTicketColumns,
  iraTicketColumns,
} from "../pageSections/FEMSDashboard/utils";
import TicketTable from "../pageSections/FEMSDashboard/components/TicketTable";
import NotificationBadges from "../pageSections/NotificationBadges";
import useAccessValidation from "../customhooks/useAccessValidation";
import usePermissionManager from "../customhooks/usePermissionManager";
import { delay } from "../common/Utility";
import MDBox from "../components/MDBox";
import { Button, Card } from "@mui/material";
import MDTypography from "../components/MDTypography";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  Axios_AMMFetchTickets,
  Axios_IRAFetchTickets,
} from "../api/axiosFunctions.js";
import MDButton from "../components/MDButton/index.js";

/* #region  Role String Value - Set User Role */
var ammHodVal = "hod";
var ammBsdVal = "bsd";
var ammFmopsVal = "fmops";
var ammFmcVal = "fmc";
var iraRequestingOfficerVal = "requestingofficer";
var iraVerifyingOfficerVal = "verifyingofficer";
var iraReviewingOfficerVal = "reviewingofficer";
var iraApprovingOfficerVal = "approvingofficer";
var othersVal = "others";
/* #endregion */

var GRID_CONTAINER_SPACING = 2;

function Page() {
  const user = useSelector((state) => state.user);
  const {
    permissionsManager,
    claimTypes,
    HasPermissions,
    HasAMMPermissions,
    HasIRAPermissions,
    HasJTAPermissions,
  } = usePermissionManager();
  const [userRoleList, setUserRoleList] = useState([]);
  const [userType, setUserType] = useState({
    AMM: undefined,
    IRA: undefined,
  });

  /* #region  Ticket Data and Inputs */

  const [dataIRA, setDataIRA] = useState({
    isLoading: true,
    data: {
      iraDraftIncidentsData: { rows: [], columns: iraTicketColumns },
      iraVerifiedIncidentsData: { rows: [], columns: iraTicketColumns },
      iraReviewedIncidentsData: { rows: [], columns: iraTicketColumns },
      iraPendingForReportIncidentsData: { rows: [], columns: iraTicketColumns },
    },
  });

  const [dataAMM, setDataAMM] = useState({
    isLoading: true,
    data: {
      ammApprovedTicketsData: { rows: [], columns: ammTicketColumns },
      ammPendingHodTicketsData: { rows: [], columns: ammTicketColumns },
      ammPendingBSDTicketsData: { rows: [], columns: ammTicketColumns },
      ammPendingFMOpsTicketsData: { rows: [], columns: ammTicketColumns },
      ammPendingDraftTicketsData: { rows: [], columns: ammTicketColumns },
      ammRejectedTicketsData: { rows: [], columns: ammTicketColumns },
      ammCancelledTicketsData: { rows: [], columns: ammTicketColumns },
    },
  });

  /* #endregion */

  /* #region  UseEffect - ValidateToken CustomHook */
  const { ValidateToken, validationAttributes, ResetUseValidation } =
    useAccessValidation();
  useEffect(() => {
    ValidateToken(user.token);
  }, []);
  /* #endregion */

  /* #region  UseEffect - Set User Role */
  /** This will determine which data to show / What Statistic Card to show */
  useEffect(() => {
    if (validationAttributes.response != undefined) {
      var _roleClaims = [];
      var _roles = [];
      // Push Roles & Role Claims
      validationAttributes.response.roles.map((item) => {
        item.role_claims.map((claim) => {
          _roleClaims.push(claim.claim_value);
        });
        _roles.push(item);
      });

      setUserRoleList(_roles);

      var _ammRole = userType.AMM;
      var _iraRole = userType.IRA;

      /* #region  Determine AMM Role */

      if (_roleClaims.includes(claimTypes.AMMHod)) {
        _ammRole = ammHodVal;
      } else if (_roleClaims.includes(claimTypes.AMMBsd)) {
        _ammRole = ammBsdVal;
      } else if (_roleClaims.includes(claimTypes.AMMfmops)) {
        _ammRole = ammFmopsVal;
      } else {
        _ammRole = ammFmcVal;
      }
      /* #endregion */

      /* #region  Determine IRA Role */
      if (_roleClaims.includes(claimTypes.IRAReview)) {
        _iraRole = iraReviewingOfficerVal;
      } else if (_roleClaims.includes(claimTypes.IRAVerify)) {
        _iraRole = iraVerifyingOfficerVal;
      } else if (_roleClaims.includes(claimTypes.IRACreate)) {
        _iraRole = iraRequestingOfficerVal;
      } else {
        _ammRole = othersVal;
      }
      /* #endregion */

      setUserType({ ...userType, AMM: _ammRole, IRA: _iraRole });
      ResetUseValidation();
    }
  }, [validationAttributes]);
  /* #endregion */

  /** Returns Array for AMM - ticketData */
  async function GetAMMData() {
    await delay(1);
    // AMM Variables
    var _amm_approvedTicketRows = [];
    var _amm_pendingHodTicketsData = [];
    var _amm_pendingBSDTicketsData = [];
    var _amm_pendingFMOpsTicketsData = [];
    var _amm_draftTicketsData = [];
    var _amm_rejectedTicketsData = [];
    var _amm_cancelledTicketsData = [];

    try {
      var res = await Axios_AMMFetchTickets(user.token);
      var response_data = res?.data ?? [];

      _amm_approvedTicketRows = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "Approved";
        })
      );
      _amm_pendingHodTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "PendingHODApproval";
        })
      );
      _amm_pendingBSDTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "PendingBSDApproval";
        })
      );
      _amm_pendingFMOpsTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "PendingFmOpsVerification";
        })
      );
      _amm_draftTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return (
            ticket.Status === "Draft" &&
            ticket.Requester_Email === user.user_name
          );
        })
      );
      _amm_rejectedTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "Rejected";
        })
      );
      _amm_cancelledTicketsData = prepareTicketRows(
        response_data.filter((ticket) => {
          return ticket.Status === "Cancelled";
        })
      );
    } catch (err) {
      console.log(err);
    } finally {
      setDataAMM({
        ...dataAMM,
        isLoading: false,
        data: {
          ammApprovedTicketsData: {
            rows: _amm_approvedTicketRows ?? [],
            columns: ammTicketColumns,
          },
          ammPendingHodTicketsData: {
            rows: _amm_pendingHodTicketsData ?? [],
            columns: ammTicketColumns,
          },
          ammPendingBSDTicketsData: {
            rows: _amm_pendingBSDTicketsData ?? [],
            columns: ammTicketColumns,
          },
          ammPendingFMOpsTicketsData: {
            rows: _amm_pendingFMOpsTicketsData ?? [],
            columns: ammTicketColumns,
          },
          ammPendingDraftTicketsData: {
            rows: _amm_draftTicketsData ?? [],
            columns: ammTicketColumns,
          },
          ammRejectedTicketsData: {
            rows: _amm_rejectedTicketsData ?? [],
            columns: ammTicketColumns,
          },
          ammCancelledTicketsData: {
            rows: _amm_cancelledTicketsData ?? [],
            columns: ammTicketColumns,
          },
        },
      });
    }

    return {
      _amm_approvedTicketRows,
      _amm_pendingHodTicketsData,
      _amm_pendingBSDTicketsData,
      _amm_pendingFMOpsTicketsData,
      _amm_draftTicketsData,
      _amm_rejectedTicketsData,
      _amm_cancelledTicketsData,
    };
  }
  /** Returns Array for IRA - ticketData */
  async function GetIRAData() {
    await delay(2);
    // AMM Variables
    var _ira_draftIncidents = [];
    var _ira_verifiedIncidents = [];
    var _ira_pendingForReportIncidents = [];
    var _ira_reviewedIncidents = [];

    try {
      var res = await Axios_IRAFetchTickets(user.token);
      var response_data = res?.data ?? [];
      _ira_verifiedIncidents = response_data.filter((ticket) => {
        return ticket.status.toLowerCase() === "supervisor review";
      });
      _ira_draftIncidents = response_data.filter((ticket) => {
        return ticket.status.toLowerCase() === "draft";
      });
      _ira_reviewedIncidents = response_data.filter((ticket) => {
        return ticket.status.toLowerCase() === "reviewed";
      });
      _ira_pendingForReportIncidents = response_data.filter((ticket) => {
        return ticket.status.toLowerCase() === "pending for report";
      });
    } catch (err) {
      console.log(err);
    } finally {
      setDataIRA({
        ...dataIRA,
        isLoading: false,
        data: {
          iraDraftIncidentsData: {
            rows: _ira_draftIncidents ?? [],
            columns: iraTicketColumns,
          },
          iraVerifiedIncidentsData: {
            rows: _ira_verifiedIncidents ?? [],
            columns: iraTicketColumns,
          },
          iraReviewedIncidentsData: {
            rows: _ira_pendingForReportIncidents ?? [],
            columns: iraTicketColumns,
          },
          iraPendingForReportIncidentsData: {
            rows: _ira_reviewedIncidents ?? [],
            columns: iraTicketColumns,
          },
        },
      });
    }

    return {
      _ira_draftIncidents,
      _ira_verifiedIncidents,
      _ira_pendingForReportIncidents,
      _ira_reviewedIncidents,
    };
  }
  /* #region  UseEffect On Init /  Axios - Fetch Tickets */
  useEffect(() => {
    // For future releases
    const fetchTickets = async () => {
      const [promise_AMM, promise_IRA] = await Promise.allSettled([
        HasAMMPermissions() && GetAMMData(),
        // HasIRAPermissions() && GetIRAData(),
      ]);

      console.log("AMM Query :", promise_AMM);
      console.log("IRA Query :", promise_IRA);
    };

    if (HasPermissions() === true) {
      // fetchTickets();
    }
  }, [HasPermissions()]);
  /* #endregion */

  /**
   * Get AMM Rows based on Role
   * @returns  {data,count,statisticsHeader}
   */
  const getAMMDataBasedOnRole = () => {
    var _roleTicketData = [];
    var statsHeader = "";
    switch (userType.AMM) {
      case ammHodVal:
        _roleTicketData = dataAMM.data.ammPendingHodTicketsData;
        statsHeader = "Pending Approval";
        break;
      case ammBsdVal:
        _roleTicketData = dataAMM.data.ammPendingBSDTicketsData;
        statsHeader = "Pending Review";
        break;
      case ammFmopsVal:
        _roleTicketData = dataAMM.data.ammPendingFMOpsTicketsData;
        statsHeader = "Pending Review";
        break;
      case ammFmcVal:
        _roleTicketData = dataAMM.data.ammFmcVal;
        statsHeader = "Pending ";
        break;
      default:
        _roleTicketData = _roleTicketData;
        statsHeader = "Pending ";
        break;
    }

    var _countData = 0;

    try {
      _countData = _roleTicketData.rows.length ?? 0;
    } catch (ex) {}

    return {
      data: _roleTicketData,
      count: _countData,
      statisticsHeader: statsHeader,
    };
  };
  /**
   * Get IRA Data based on Role
   * @returns  {data,count,statisticsHeader}
   */
  const getIRADataBasedOnRole = () => {
    var _roleTicketData = { row: [], columns: iraTicketColumns };

    var statsHeader = "";
    switch (userType.IRA) {
      case iraRequestingOfficerVal:
        _roleTicketData = dataIRA.data.iraDraftIncidentsData;
        statsHeader = "Pending Verification";
        break;
      case iraVerifyingOfficerVal:
        _roleTicketData = dataIRA.data.iraDraftIncidentsData;
        statsHeader = "Pending Verification";
        break;
      case iraReviewingOfficerVal:
        _roleTicketData = dataIRA.data.iraVerifiedIncidentsData;
        statsHeader = "Pending Review";
        break;
      case iraApprovingOfficerVal:
        _roleTicketData = _roleTicketData;
        statsHeader = "Incidents";
        break;
      default:
        _roleTicketData = _roleTicketData;
        statsHeader = "Incidents";
        break;
    }

    var _iraCount = 0;

    try {
      _iraCount = _roleTicketData?.rows?.length ?? 0;
    } catch (ex) {}

    return {
      data: _roleTicketData,
      count: _iraCount,
      statisticsHeader: statsHeader,
    };
  };

  const prepareNotificationBadge = () => {
    var _totalCount = 0;
    try {
      _totalCount +=
        getAMMDataBasedOnRole().count + getIRADataBasedOnRole().count;
    } catch (ex) {}

    return _totalCount;
  };

  const DashboardStatisticCards = () => {
    var _statsBoard = [];

    const _ammMainStatsCard = () => {
      return (
        <StatisticsCard
          count={getAMMDataBasedOnRole().count}
          title={getAMMDataBasedOnRole().statisticsHeader}
          subtitle={"[ AMM ]".toUpperCase()}
          bgColor={colors.JTC.jtcblue2}
          color={"success"}
          icon={
            <PlaylistAddCheckCircleIcon
              color={colors.black.focus}
              fontSize="large"
            />
          }
          loading={dataAMM.isLoading}
        />
      );
    };
    const _iraMainStatsCard = () => {
      return (
        <StatisticsCard
          count={getIRADataBasedOnRole().count}
          title={getIRADataBasedOnRole().statisticsHeader}
          subtitle={"[ IRA ]".toUpperCase()}
          bgColor={colors.JTC.jtcblue2}
          color={"success"}
          icon={
            <PlaylistAddCheckCircleIcon
              color={colors.black.focus}
              fontSize="large"
            />
          }
          loading={dataIRA.isLoading}
        />
      );
    };
    const _systemRolesStatsCard = () => {
      return (
        <StatisticsCard
          count={user.roles.length}
          title={"System Role (s)"}
          subtitle={"-"}
          bgColor={colors.JTC.jtcblue2}
          color={"success"}
          icon={
            <AdminPanelSettingsIcon
              color={colors.black.focus}
              fontSize="large"
            />
          }
          loading={false}
        />
      );
    };

    // Select the StatisticCards to display
    if (HasAMMPermissions()) {
      // _statsBoard.push(_ammMainStatsCard());
    }
    if (HasIRAPermissions()) {
      // _statsBoard.push(_iraMainStatsCard());
    }
    if (_statsBoard.length === 0) {
      _statsBoard.push(_systemRolesStatsCard());
    }

    return (
      <Grid
        container
        display={"flex"}
        direction={"row"}
        spacing={GRID_CONTAINER_SPACING}
        pt={5}
      >
        {_statsBoard.map((statisticsElement, index) => {
          return (
            <Grid
              item
              xs={12}
              md={4}
              key={`statisticsCardPortal$101_${index}`}
              sx={{ pb: { xs: 2, md: 0 } }}
            >
              {statisticsElement}
            </Grid>
          );
        })}
      </Grid>
    );
  };

  return (
    <PageLayout padding={3} isAuthenticated={true}>
      <NotificationBadges
        notificationBadgeContent={prepareNotificationBadge()}
        user_name={user.user_name}
        listOfRoles={userRoleList}
      />

      <DashboardApplicationContainer />
      {/* <MDBox pt="2em">
        <Card sx={{ height: "15em" }}>
          <MDBox p={2}>
            <h6>Coming Soon . . .</h6>
          </MDBox>
        </Card>
      </MDBox> */}

      {/* {DashboardStatisticCards()}/ */}

      {/* 
        {HasAMMPermissions() && (
        <TicketTable
          title="Asset Management Module (AMM)"
          ticketData={getAMMDataBasedOnRole().data}
          defaultValue={5}
          loading={dataAMM.isLoading}
        />
      )}
      {HasIRAPermissions() && (
        <TicketTable
          title="Incident Reporting Application (IRA)"
          ticketData={getIRADataBasedOnRole().data}
          defaultValue={5}
          loading={dataIRA.isLoading}
        />
      )} */}
    </PageLayout>
  );
}

export default Page;
